<template>
  <div>
    <div class="container">
      <div v-if="isLoading" style="padding-top: 100px;" class="container has-text-centered opaque">
        <i class="fa fa-refresh fa-spin fa-4x"></i>
        <p>Loading...</p>
      </div>
      <div v-if="!isLoading" class="container crud-page-header">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li>
              <router-link to="/associations">Associations</router-link>
            </li>
            <li class="is-active">
              <router-link to="/associations">{{association.Name}}</router-link>
            </li>
          </ul>
        </nav>
        <div class="field crud-buttons is-grouped is-pulled-right">
          <div class="control hide-mobile">
            <button class="button is-text" @click="cancel">Back</button>
          </div>
          <div class="control">
            <button v-if="isNewAssociation" @click="postAssociation(association)" class="button is-link">Create</button>
            <button v-if="!isNewAssociation" @click="putAssociation(association)" :class="{'is-loading': isSaving}"
              class="button is-link">Save</button>
          </div>
          <div class="control" v-if="!isNewAssociation">
            <!-- hidden anchor -->
            <a ref="pdf" :download="fileName" :href="pdflink"></a>
            <button class="button is-link hide-mobile" :class="{'is-loading': isGeneratingPdf}" @click="getPdf">
              Preview
              <i style="padding-left: 10px;" class="fa fa-lg fa-file-pdf-o"></i>
            </button>
            <button class="button is-link hide-desktop" :class="{'is-loading': isGeneratingPdf}" @click="getPdf">
              <i class="fa fa-lg fa-file-pdf-o"></i>
            </button>
          </div>
          <div class="control" v-if="!isNewAssociation">
            <el-popover ref="popover5" placement="bottom" width="500" v-model="showLinkPopover" title="Certificate Request Link">
              <p>{{link}}</p>
            </el-popover>
            <button class="button is-link" v-popover:popover5>
              <i class="fa fa-lg fa-link"></i>
            </button>
          </div>
          <div class="control" v-if="!isNewAssociation">
            <button class="button is-link hide-mobile" @click="postRequest(association)">
              Copy to Request
            </button>
            <button class="button is-link hide-desktop" @click="postRequest(association)">
              Copy
            </button>
          </div>
        </div>
        <div class="section hide-mobile">
          <h3 class="title is-5">Association Information</h3>
          <hr>
        </div>
      </div>
    </div>
    <div v-if="!isLoading" class="container crud-body">
      <section class="section">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label is-small">Association Name</label>
              <div class="control">
                <input class="input is-small" v-model="association.Name" :class="{'is-required': missingName}" type="text"
                  placeholder="Homeowners Association Name">
              </div>
              <p v-if="missingName" class="help is-danger">
                Please set Association Name
              </p>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label is-small">Access Pin Number
              </label>
              <div class="control">
                <input class="input is-small" v-model="association.PinNumber" :class="{'is-required': invalidPinNumber}"
                  type="text" placeholder="Pin Number">
              </div>
              <p v-if="missingPinNumber" class="help is-danger">
                Please set Pin Number
              </p>
              <p v-if="duplicatePinNumber" class="help is-danger">
                Pin Number already used, please use a different number
              </p>
              <p v-if="shortPinNumber" class="help is-danger">
                Pin Number must be at least 5 characters
              </p>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label is-small">Status
              </label>
              <div class="control">
                <div class="select" style="width: 100%">
                  <select class="input is-small" v-model="association.Status" type="text" placeholder="Status">
                    <option value="draft">Draft - Not Published</option>
                    <option value="active">Active - Published</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="section">
        <div class="columns is-variable is-5 is-desktop" style="overflow: scroll;">
          <div class="column">
            <Accord24 :accord24="association.Accord24"></Accord24>
            <Accord24 style="display: none;" ref="accord" :accord24="association.Accord24" :readonly="true"></Accord24>
          </div>
          <div class="column">
            <input style="display: none;" multiple @change="handleFileSelected" id="uploadInput" type="file">
            <button class="button is-light" @click="attach" :class="{'is-loading': isAttaching}">Additional
              Declarations
              <i style="margin-left: 10px;" class="fa fa-paperclip"></i>
            </button>
            <div style="word-break: break-all;"">
            <table class="table" style="margin-top: 5px;">
              <tr v-for="attachment in association.Attachments">
                <td><a :href="attachment.downloadURL" target="_blank">{{attachment.fileName}}</a></td>
                <td><i class="fa fa-times" @click="deleteAttachment(attachment)" style="margin-left: 8px; cursor: pointer;"
                  aria-hidden="true"></i></td>
              </tr>
            </table>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="modal" :class="{'is-active': showCopyToRequestModal}">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Copy to Request</p>
            <button @click="showCopyToRequestModal = false" class="delete"></button>
          </header>
          <div>
            <section class="modal-card-body">
              <div class="content">
                <div class="field">
                  <label class="label">Property Owner Full Name</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="Enter Property Owner Full Name" v-model="request.PropertyOwnerName">
                  </div>
                </div>

                <div class="field">
                  <label class="label">Property Address</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="Enter Property Address" v-model="request.PropertyAddress">
                  </div>
                </div>

                <div class="field">
                  <label class="label">Loan Number</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="Enter Loan Number" v-model="request.LoanNumber">
                  </div>
                </div>

                <div class="field">
                  <label class="label">Certificate Holder</label>
                  <div class="control">
                    <textarea class="textarea" type="text" style="resize: none;" placeholder="Enter Lender Certificiate Holder Information"
                      v-model="request.CertificateHolder"></textarea>
                  </div>
                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
              <a class="button is-success" @click="postRequest(this.association)">Continue</a>
              <a @click="showCopyToRequestModal = false" class="button">Cancel</a>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import tenant from '@/tenant'
  import Accord24 from '@/components/associations/Accord24'
  import accordUtil from '@/utilities/accord-util'
  import axios from 'axios'

  export default {
    name: 'Association',
    data: function () {
      return {
        isLoading: true,
        isSaving: false,
        isAttaching: false,
        isGeneratingPdf: false,
        isNewAssociation: false,
        showCopyToRequestModal: false,
        showLinkPopover: false,
        missingName: false,
        missingPinNumber: false,
        duplicatePinNumber: false,
        invalidPinNumber: false,
        shortPinNumber: false,
        association: {
          PinNumber: '',
          Name: '',
          Status: 'draft',
          Attachments: [],
          Accord24: {
            AuthorizedRepresentative: '',
            CertificateHolder: '',
            CertificateNumber: '',
            ContactEmailAddress: '',
            ContactName: '',
            FaxNumber: '',
            Insured: '',
            InsurerA_NAIC: '',
            InsurerA_Name: '',
            InsurerB_NAIC: '',
            InsurerB_Name: '',
            InsurerC_NAIC: '',
            InsurerC_Name: '',
            InsurerD_NAIC: '',
            InsurerD_Name: '',
            InsurerE_NAIC: '',
            InsurerE_Name: '',
            InsurerF_NAIC: '',
            InsurerF_Name: '',
            InsurerLetter1: '',
            InsurerLetter1_BlanketBuildingAndPersonalPropertyLimit: '',
            InsurerLetter1_BlanketBuildingLimit: '',
            InsurerLetter1_BlanketPersonalPropertyLimits: '',
            InsurerLetter1_BuildingDeductible: '',
            InsurerLetter1_BuildingLimits: '',
            InsurerLetter1_BusinessIncomeLimit: '',
            InsurerLetter1_EarthquakeDeductible: '',
            InsurerLetter1_EffectiveDate: '',
            InsurerLetter1_ExpirationDate: '',
            InsurerLetter1_ExtraExpenseLimit: '',
            InsurerLetter1_FloodDeductible: '',
            InsurerLetter1_IsBasic: '',
            InsurerLetter1_IsBlanketBuilding: '',
            InsurerLetter1_IsBlanketBuildingAndPersonalProperty: '',
            InsurerLetter1_IsBlanketPersonalProperty: '',
            InsurerLetter1_IsBroad: '',
            InsurerLetter1_IsBuilding: '',
            InsurerLetter1_IsBusinessIncome: '',
            InsurerLetter1_IsEarthquake: '',
            InsurerLetter1_IsExtraExpense: '',
            InsurerLetter1_IsFlood: '',
            InsurerLetter1_IsOtherInsurance1: '',
            InsurerLetter1_IsOtherInsurance2: '',
            InsurerLetter1_IsOtherProperty1: '',
            InsurerLetter1_IsOtherProperty2: '',
            InsurerLetter1_IsPersonalProperty: '',
            InsurerLetter1_IsProperty: '',
            InsurerLetter1_IsRentalValue: '',
            InsurerLetter1_IsSpecial: '',
            InsurerLetter1_IsWind: '',
            InsurerLetter1_OtherDeductible1: '',
            InsurerLetter1_OtherDeductible2: '',
            InsurerLetter1_OtherInsurance1: '',
            InsurerLetter1_OtherInsurance2: '',
            InsurerLetter1_OtherProperty1: '',
            InsurerLetter1_OtherProperty2: '',
            InsurerLetter1_OtherPropertyLimit1: '',
            InsurerLetter1_OtherPropertyLimit2: '',
            InsurerLetter1_PersonalPropertyLimit: '',
            InsurerLetter1_PolicyNumber: '',
            InsurerLetter1_RentalValueLimit: '',
            InsurerLetter1_WindDeductible: '',
            InsurerLetter2: '',
            InsurerLetter2_EffectiveDate: '',
            InsurerLetter2_ExpirationDate: '',
            InsurerLetter2_IsInlandMarine: '',
            InsurerLetter2_IsNamedPerils: '',
            InsurerLetter2_IsOtherInsurance4: '',
            InsurerLetter2_IsOtherProperty1: '',
            InsurerLetter2_IsOtherProperty2: '',
            InsurerLetter2_IsOtherProperty3: '',
            InsurerLetter2_IsOtherProperty4: '',
            InsurerLetter2_OtherInsurance4: '',
            InsurerLetter2_OtherProperty1: '',
            InsurerLetter2_OtherProperty2: '',
            InsurerLetter2_OtherProperty3: '',
            InsurerLetter2_OtherProperty4: '',
            InsurerLetter2_OtherPropertyLimit1: '',
            InsurerLetter2_OtherPropertyLimit2: '',
            InsurerLetter2_OtherPropertyLimit3: '',
            InsurerLetter2_OtherPropertyLimit4: '',
            InsurerLetter2_PolicyNumber: '',
            InsurerLetter2_PolicyType: '',
            InsurerLetter3: '',
            InsurerLetter3_EffectiveDate: '',
            InsurerLetter3_ExpirationDate: '',
            InsurerLetter3_IsCrime: '',
            InsurerLetter3_IsOtherProperty1: '',
            InsurerLetter3_IsOtherProperty2: '',
            InsurerLetter3_IsOtherProperty3: '',
            InsurerLetter3_OtherProperty1: '',
            InsurerLetter3_OtherProperty2: '',
            InsurerLetter3_OtherProperty3: '',
            InsurerLetter3_OtherPropertyLimit1: '',
            InsurerLetter3_OtherPropertyLimit2: '',
            InsurerLetter3_OtherPropertyLimit3: '',
            InsurerLetter3_PolicyNumber: '',
            InsurerLetter3_PolicyType: '',
            InsurerLetter4: '',
            InsurerLetter4_EffectiveDate: '',
            InsurerLetter4_ExpirationDate: '',
            InsurerLetter4_IsBoiler: '',
            InsurerLetter4_IsOtherProperty1: '',
            InsurerLetter4_IsOtherProperty2: '',
            InsurerLetter4_OtherProperty1: '',
            InsurerLetter4_OtherProperty2: '',
            InsurerLetter4_OtherPropertyLimit1: '',
            InsurerLetter4_OtherPropertyLimit2: '',
            InsurerLetter4_PolicyNumber: '',
            InsurerLetter5: '',
            InsurerLetter5_EffectiveDate: '',
            InsurerLetter5_ExpirationDate: '',
            InsurerLetter5_IsOtherProperty1: '',
            InsurerLetter5_IsOtherProperty2: '',
            InsurerLetter5_OtherInsurance1: '',
            InsurerLetter5_OtherProperty: '',
            InsurerLetter5_OtherProperty2: '',
            InsurerLetter5_OtherPropertyLimit1: '',
            InsurerLetter5_OtherPropertyLimit2: '',
            InsurerLetter5_PolicyNumber: '',
            PhoneNumber: '',
            Producer: '',
            ProducerCustomerId: '',
            PropertyDescription: '',
            RevisionNumber: '',
            SpecialConditions: ''
          }
        },
        request: {

        },
        fileName: '',
        pdflink: ''
      }
    },
    created: function () {
      tenant.initialize().then(() => {
        this.initialize(this.$route)
      })
    },
    methods: {
      initialize(route) {
        window.document.title = 'Associations'
        this.isNewAssociation = route.params.id === 'new'
        if (!this.isNewAssociation) {
          this.fetchAssociation(route.params.id)
        } else {
          this.isLoading = false
        }
      },
      fetchAssociation(Id) {
        tenant.ref('associations/' + Id).once('value').then((snapshot) => {
          this.association = snapshot.val()
          console.log(this.association)
          if (!this.association.Attachments) {
            this.association.Attachments = []
            this.putAssociation(this.association)
          }
          this.isLoading = false
        })
      },
      postAssociation(association) {
        if (!this.validate(association)) {
          return
        }

        tenant.ref('pins').once('value').then((snapshot) => {
          let allPins = snapshot.val()
          for (let pinKey in allPins) {
            if (allPins.hasOwnProperty(pinKey)) {
              if (allPins[pinKey] === association.PinNumber) {
                this.invalidPinNumber = true
                this.duplicatePinNumber = true
                this.isSaving = false
                return
              }
            }
          }

          let response = tenant.ref('associations').push(association)
          this.isNewAssociation = false

          this.setReferenceData(response.key, association)
          this.$router.push('/associations/' + response.key)
        })
      },
      putAssociation(association) {
        if (!this.validate(association)) {
          return
        }

        let key = this.$route.params.id
        this.isSaving = true
        tenant.ref('pins').once('value').then((snapshot) => {
          let allPins = snapshot.val()
          for (let pinKey in allPins) {
            if (allPins.hasOwnProperty(pinKey)) {
              if (pinKey !== key && allPins[pinKey] === association.PinNumber) {
                this.invalidPinNumber = true
                this.duplicatePinNumber = true
                this.isSaving = false
                return
              }
            }
          }

          tenant.ref('associations/' + key).set(association).then(() => {
            this.isSaving = false
          })
          this.setReferenceData(key, association)
        })
      },
      setReferenceData(key, association) {
        if (association.Status !== 'draft') {
          tenant.firebaseDb.ref('lists/agencies/' + tenant.name + '/associations/' + key).set(association.Name)
        }

        if (association.Status === 'draft') {
          tenant.firebaseDb.ref('lists/agencies/' + tenant.name + '/associations/' + key).remove()
        }

        tenant.ref('pins/' + key).set(association.PinNumber)
      },
      validate(association) {
        this.missingPinNumber = false
        this.missingName = false
        this.invalidPinNumber = false
        this.duplicatePinNumber = false
        this.shortPinNumber = false

        if (!association.PinNumber || !association.Name || association.PinNumber.length < 5) {
          if (!association.PinNumber) {
            this.invalidPinNumber = true
            this.missingPinNumber = true
          }
          if (!association.Name) {
            this.missingName = true
          }
          if (association.PinNumber.length < 5) {
            this.invalidPinNumber = true
            this.shortPinNumber = true
          }
          return false
        }

        return true
      },
      postRequest(association) {
        let d = new Date()
        if (tenant.user) {
          let request = {
            Association: association,
            Date: d.toISOString(),
            RequesterEmail: tenant.user.email
          }
          let response = tenant.ref('requests').push(request)
          this.$router.push('/requests/' + response.key)
        }
      },
      getPdf() {
        this.isGeneratingPdf = true

        // go ahead and do a save
        let key = this.$route.params.id
        tenant.ref('associations/' + key).set(this.association)

        let accordForm = this.$refs['accord'].$el.innerHTML
        let rawHTML = this.getAccordDOM(accordForm)
        axios.post(process.env.API_BASE_URL + '/api/certificates/pdf', rawHTML, { responseType: 'arraybuffer' }).then((response) => {
          let blob = new Blob([response.data], { type: 'application/pdf' })
          this.isGeneratingPdf = false
          if (navigator.appVersion.toString().indexOf('.NET') > 0) {
            this.isIE = true
            window.navigator.msSaveBlob(blob, 'InsuranceCertificate.pdf')
          } else {
            this.pdflink = window.URL.createObjectURL(blob)
            this.fileName = 'InsuranceCertificate.pdf'
            this.$nextTick(() => {
              this.$refs['pdf'].click()
            })
          }
        }).catch((error) => {
          this.isGeneratingPdf = false
          console.log(error)
        })
      },
      getAccordDOM(accordForm) {
        return accordUtil.getAccordDOM(accordForm)
      },
      cancel() {
        this.$router.push('/associations')
      },
      attach() {
        document.getElementById('uploadInput').click()
      },
      handleFileSelected() {
        let files = document.getElementById('uploadInput').files
        for (let i = 0; i < files.length; i++) {
          let file = files[i]
          let key = this.$route.params.id

          let metadata = {
            contentType: 'application/pdf'
          }
          this.isAttaching = true
          tenant.firebaseStorage.ref().child(`attachments/${key}/${file.name}`).put(file, metadata).then(response => {
            if (this.association.Attachments) {
              this.association.Attachments.push({
                downloadURL: response.downloadURL,
                fileName: response.metadata.name
              })
              this.putAssociation(this.association)
              if (i === files.length - 1) {
                this.isAttaching = false
              }
            }
          })
        }
      },
      deleteAttachment(attachment) {
        let key = this.$route.params.id
        this.isAttaching = true
        tenant.firebaseStorage.ref().child(`attachments/${key}/${attachment.fileName}`).delete().then(() => {
          let index = this.association.Attachments.findIndex(x => x.fileName === attachment.fileName)
          this.association.Attachments.splice(index, 1)
          this.putAssociation(this.association)
          this.isAttaching = false
        })
      }
    },
    watch: {
      '$route'() {
        this.initialize(this.$route)
      }
    },
    computed: {
      link: function () {
        return window.location.origin + '/certificates/' + tenant.name + '/' + this.association.PinNumber
      }
    },
    components: {
      Accord24
    }
  }

</script>

<style scoped>
  .request-title {
    margin-bottom: 20px;
    font-size: 24px;
  }

  .breadcrumb {
    margin-bottom: 0px;
  }

  .section {
    padding-bottom: 0px;
  }

  .select:not(.is-multiple)::after {
    margin-top: -0.65em;
  }
</style>


// WEBPACK FOOTER //
// src/components/associations/Association.vue?74a0fc8a